import { useSyncExternalStore } from "react";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useVisibilityChangeSubscribe = (callback: (event: Event) => any) => {
  document.addEventListener("visibilitychange", callback);
  return () => {
    document.removeEventListener("visibilitychange", callback);
  }
}

const getVisibilityChangeSnapshot = () => {
  return document.visibilityState;
};

export default function useIsVisible() {
  const visibilityState = useSyncExternalStore(
    useVisibilityChangeSubscribe,
    getVisibilityChangeSnapshot
  );

  return visibilityState === "visible";
}
